<template>
    <form
        class="form basic-form trip-form"
        autocomplete="off"
        novalidate
        @submit="emitSubmit"
    >
        <div class="form-field">
            <label for="email">Email:</label>
            <input
                id="email"
                v-model="form.email.value"
                type="email"
                autocomplete="email"
            />
            <FormError :errors="errors.email" />
        </div>

        <div class="form-field">
            <label for="password">Password:</label>
            <input
                id="password"
                v-model="form.password.value"
                type="password"
                autocomplete="new-password"
            />
            <FormError :errors="errors.password" />
        </div>

        <div class="form-field">
            <label for="password_confirmation">Password confirmation:</label>
            <input
                id="password_confirmation"
                v-model="form.password_confirmation.value"
                type="password"
                autocomplete="new-password"
            />
            <FormError :errors="errors.password_confirmation" />
        </div>

        <Bttn id="submit-register" type="submit">Save</Bttn>
    </form>
</template>

<script>
import BaseForm from "js/components/base/BaseForm.js";
import FormError from "js/components/forms/FormError";

export default {
    name: "RegisterForm",
    components: {
        FormError,
    },
    extends: BaseForm,
    data() {
        return {
            form: {
                email: {
                    value: "",
                },
                password: {
                    value: "",
                },
                password_confirmation: {
                    value: "",
                },
            },
        };
    },
};
</script>
